module.exports = __webpack_public_path__ + "static/media/总建筑面积.70dd3885.svg";